'use strict';

const React = require( 'react' );
const classNames = require( 'classnames' );
const LocationDropDown = require( './location-dropdown.jsx' );
const TerminalSelect = require( './terminal-dropdown.jsx' );
const TimeSelect = require( './times-dropdown.jsx' );
const FlightLookUp = require( './flightLookUp.jsx' );
const SearchButton = require( './searchButton.jsx' );
const EngineHelper = require( './engineHelper.js' );
const DateHelper = require( '../../../../../_plugins/lib/dateHelper.js' );
const propTypes = require('prop-types');
const HiddenInputs = require( './hiddenInputs.jsx' );
const { string, object, bool } = propTypes;
const createReactClass = require('create-react-class');

const ParkingEngine = createReactClass({
  mixins: [EngineHelper],

  propTypes: {
    Location: string,
    domainSettings: object,
    formSettings: object,
    ArrivalDate: propTypes.instanceOf(Date),
    DepartDate: propTypes.instanceOf(Date),
    engineSearchField: string,
    hiddenLocation: string,
    agentData: object,
    agentSettings: object,
    selected: string,
    locations: object,
    pageData: object,
    showFlight: bool
  },

  getInitialState() {
    const { hiddenLocation, Location, formSettings } = this.props;
    return {
      hiddenInputs: {},
      terminalLocation: hiddenLocation || Location || formSettings.defaultParkingLocation
    };
  },

  getDefaultProps() {
    return {
      hiddenLocation: '',
      engineSearchField: '',
      ArrivalDate: DateHelper.alterDateByNumberOfDays( new Date( ), 1 ),
      DepartDate: DateHelper.alterDateByNumberOfDays( new Date( ), 8 ),
      selected: 'cp',
      showFlight: true
    };
  },

  componentDidMount() {
    this.getHiddenInputs( );
  },

  /**
  * Get the name of the page the user is currently on
  * @returns {string} - The name of the page with the .html extension, if on the home page returns an empty string.
  */
  getFullPageName () {
    const { pageData: { pageName } } = this.props
    return pageName !== 'index' ? `${pageName}.html` : ''
  },

  locationSelected( terminalLocation ) {
    this.setState({ terminalLocation });
  },

  showTerminals( ) {
    const { locations } = this.props;
    const { terminalLocation } = this.state;
    return locations.terminals && locations.terminals[terminalLocation];
  },

  render() {
    const {
      Location,
      pageData: { pageName },
      domainSettings,
      ArrivalDate,
      DepartDate,
      engineSearchField,
      hiddenLocation,
      agentData,
      selected,
      formSettings,
      locations,
      showFlight
    } = this.props;
    const pagesName = this.getFullPageName();
    const { hiddenInputs, terminalLocation } = this.state;
    const { agent, typeRID, groupCode } = agentData;
    const terminals = this.showTerminals( );
    const arrivalDate = DateHelper.formatDateToDMY( ArrivalDate );
    const departDate = DateHelper.formatDateToDMY( DepartDate );
    const arrivalDateFormatted = DateHelper.formatDateToDddMMyy( ArrivalDate );
    const departDateFormatted = DateHelper.formatDateToDddMMyy( DepartDate );
    const activeClass = classNames({
      'active': selected === 'cp',
      'cp': true,
      'engine': true
    });
    const terminalClass = classNames({
      'col-xs-4': !hiddenLocation
    });
    const terminalSelectClass = classNames({
      'col-xs-12': hiddenLocation
    });
    const defaultInputs = {
      agentgroup: groupCode,
      channel: typeRID,
      agent: agent,
      product: 'cp',
      selectProduct: 'cp',
      request: '1',
      Referer: 'http://' + domainSettings.domain + '/' + pagesName,
      domain: domainSettings.domain,
      lang: 'en',
      rule_set: formSettings.ruleset
    };

    return (
      <div className={ activeClass }>
        <form id="parkingEngine" acceptCharset="UTF-8" action={ formSettings.parkingAction } className="hxEmbed clearfix" method={ formSettings.method }>

          <div className="options">
            <ul className="unstyled">

              { !hiddenLocation ?
                <li className="col-xs-8">
                  <div>
                    <label>Flying from?</label>
                    <LocationDropDown activeLocation={ Location || formSettings.defaultParkingLocation } locations={ locations.carParking } onSelect={ this.locationSelected } />
                  </div>
                </li>
              :
                <input name="Location" type="hidden" className="l" value={ hiddenLocation } data-track-name="location" />
              }

              { terminals && (
                <li className={ terminalClass }>
                  <label>Terminal</label>
                  <TerminalSelect className={ terminalSelectClass } name="terminal" pagesName={ pagesName } locations={ locations } location={ terminalLocation } />
                </li>
              )}

              <li style={{ clear: 'left' }}>
                <label>Parking from</label>

                <div className="clearfix">
                  <div className="col-xs-8 datePicker calendarEmbed">
                    <input className="alternateDA col-xs-12 hxtrack" defaultValue={arrivalDateFormatted} />
                    <input className="dA" name="ArrivalDate" defaultValue={arrivalDate} type="hidden" />
                    <div />
                  </div>
                  <TimeSelect name="ArrivalTime" activeTime={ formSettings.defaultArrivalTime } pagename={ pageName } />
                </div>
              </li>

              <li>
                <label>Returning to collect car</label>

                <div className="clearfix">
                  <div className="col-xs-8 datePicker calendarEmbed">
                    <input className="alternateDD col-xs-12 hxtrack" defaultValue={departDateFormatted} />
                    <input className="dD" name="DepartDate" defaultValue={departDate} type="hidden" />
                    <div />
                  </div>
                  <TimeSelect name="DepartTime" activeTime={ formSettings.defaultDepartTime } pagename={ pageName } />
                </div>
              </li>

              { showFlight && (
                <FlightLookUp tracking="engine-cp-outbound-flight" labelText="Flight (for the best offers and services)" placeholderText="eg. 'easyJet', 'orlando' or 'VS27'" helpText="Don't know your flight number? (<a href='#' id='flightFinderHelp'>Help me find my flight</a>)" />
              )}

              <SearchButton />
            </ul>
          </div>

          <HiddenInputs inputs={ defaultInputs } />
          { engineSearchField && (
            <input name="search" type="hidden" value={ engineSearchField } />
          )}
          <HiddenInputs inputs={ hiddenInputs } />
        </form>
      </div>
    );
  }
});

module.exports = ParkingEngine;






// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/engines/parking-engine.jsx